import React from 'react';
import { Modal, Icon } from 'antd';
import './confirmModal.css';

const confirm = Modal.confirm;

export const showConfirmPutArchive = (obj) => {
    confirm({
        title: 'Внимание!',
        icon: <Icon type="question-circle" />,
        content: <span>Вы уверены, что хотите архивировать ТС?<br />ТС будет недоступно для назначения на заказы.</span>,
        cancelText: 'Отмена',
        okText: 'Архивировать',
        centered: true,
        className: 'warningVehiclCardConfirm',
        ...obj
    });
};

export const showConfirmRestorefromArchive = (obj) => {
    confirm({
        title: 'Внимание!',
        icon: <Icon type="question-circle" />,
        content: <span>Вы действительно хотите восстановить ТС?<br />Назначение на заказы для этого ТС станет доступно.</span>,
        cancelText: 'Отмена',
        okText: 'Восстановить',
        centered: true,
        className: 'blueVehicleCardConfirm',
        ...obj
    });
};

export const showConfirmAbortEdit = (obj) => {
    confirm({
        title: 'Внимание!',
        icon: <Icon type="question-circle" />,
        content: <span>Вы действительно хотите отменить редактирование<br />ТС? Данные будут удалены!</span>,
        cancelText: 'Отмена',
        okText: 'Отменить изменения',
        centered: true,
        className: 'warningVehiclCardConfirm',
        ...obj
    });
};

export const showConfirmSaveEdit = (obj) => {
    confirm({
        title: 'Внимание!',
        icon: <Icon type="question-circle" />,
        content: <span>Вы действительно хотите сохранить внесенные <br />изменения?</span>,
        cancelText: 'Отмена',
        okText: 'Сохранить изменения',
        centered: true,
        className: 'blueVehicleCardConfirm',
        ...obj
    });
};

export const showConfirmCancelAdding = (obj) => {
    confirm({
        title: 'Внимание!',
        icon: <Icon type="question-circle" />,
        content: <span>Вы действительно хотите отменить добавление<br/>ТС? Данные будут удалены!</span>,
        cancelText: 'Отмена',
        okText: 'Отменить добавление',
        centered: true,
        className: 'warningVehiclCardConfirm',
        ...obj
    });
};




